import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Divider,
  Link,
  Typography,
} from '@mui/material';

import { cartOrNewsletterDocumentPropType } from 'generic/core/qes/proptypes';
import QES_CONSTANTS from 'generic/core/qes/constants';
import { overrideRessource } from 'generic/utils/utils';

const { default: useDocumentFields } = overrideRessource('core/hooks/useDocumentFields', true);
const { CLICK_ON_DOCS_TITLE_BEHAVIOR } = QES_CONSTANTS;

const DocumentForNewsletter = ({
  panierDocument,
  handleGetDocumentComplete,
}) => {
  const {
    title, linkout, date, source,
  } = useDocumentFields(panierDocument);

  let titleLinkProps;
  if (CLICK_ON_DOCS_TITLE_BEHAVIOR === 'newTab') {
    titleLinkProps = {
      component: Link,
      href: linkout,
      rel: 'noopener',
      target: '_blank',
      underline: 'none',
    };
  } else if (CLICK_ON_DOCS_TITLE_BEHAVIOR === 'complete') {
    titleLinkProps = {
      component: 'span',
      onClick: handleGetDocumentComplete,
    };
  }

  return (
    <Box display="block" alignItems="center">
      <Typography
        component="span"
        display="block"
      >
        <Box
          {...titleLinkProps}
          color="text.primary"
          sx={{ cursor: 'pointer' }}
        >
          {title}
        </Box>

        <Box
          color="text.neutral"
        >
          {panierDocument.texte}
        </Box>
      </Typography>

      <Box
        display="flex"
        flexWrap="wrap"
        flexGrow="1"
        lineHeight="1rem"
        sx={{ wordBreak: 'break-word' }}
      >
        {date && (
          <Fragment>
            <Typography
              component="span"
              variant="body2"
              color="text.neutral"
              fontSize="0.8rem"
            >
              {date}
            </Typography>
            <Box mx={1} py="3px">
              <Divider
                orientation="vertical"
              />
            </Box>
          </Fragment>
        )}
        {source && (
          <Typography
            component="span"
            variant="body2"
            color="text.neutral"
            fontSize="0.8rem"
          >
            {source}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

DocumentForNewsletter.propTypes = {
  panierDocument: cartOrNewsletterDocumentPropType.isRequired,
  handleGetDocumentComplete: PropTypes.func,
};

DocumentForNewsletter.defaultProps = {
  handleGetDocumentComplete: null,
};

export default DocumentForNewsletter;
